import axios from "@configs/axios";
import { API_BASE_URL, suggests } from "@utils/constants/apiRoutes";
import { RawSuggestion } from "@customTypes/autosuggest";

export type LoadSuggestionsResponse = { data: { resultList: RawSuggestion[] } };

const loadSuggestions = (limit: number, word: string, types: string[]) => {
  const params = {
    limit,
    word,
    types,
    origin: "SEARCH",
    allowRepeatedTitles: false,
  };

  const url = `${API_BASE_URL}${suggests.BASE_URL}${suggests.SEARCH_URL}`;

  return axios.post<typeof params, LoadSuggestionsResponse>(url, params);
};

export const loadCustomersSuggestion = (word: string): Promise<LoadSuggestionsResponse> => {
  return loadSuggestions(15, word, ["C_CONTACT"]);
};

export default {
  loadSuggestions,
};
